import { gsap } from 'gsap';
import { Container, Sprite } from 'src/game/minigame/match2-timestep/odie';

const PI_2 = Math.PI * 2;

interface Bee {
  sprite: Sprite;
  params: { angle: number; value: number; turn: number };
}

export default class SurroundingBees {
  private _view: Container;
  private _bees: Bee[] = [];
  private _radius: number;

  constructor(parent: Container, radius: number) {
    this._view = parent;
    this._radius = radius;
    this._createBees();
  }

  private _createBees() {
    const amount = 3;
    const hiveOffset = Math.random() * PI_2;

    for (let index = 0; index < amount; index++) {
      const sprite = Sprite.from('fx.hive/fx.hive.bee.png');
      const bee = {
        sprite,
        params: {
          angle: 0,
          value: 0,
          turn: 0,
        },
      };
      sprite.anchorX = sprite.anchorY = 0.5;
      this._bees.push(bee);
      this._view.addChild(sprite);

      const offsetSection = PI_2 / amount;
      const offset = offsetSection * index;
      this._animateBee(
        bee,
        hiveOffset + offset,
        hiveOffset + offset,
        Math.random() > 0.5,
      );
    }
  }

  private _animateBee(
    bee: Bee,
    angleOffset = 0,
    ratioOffset = 0,
    reverse = false,
  ) {
    const duration = 15;
    const sign = reverse ? -1 : 1;

    gsap.to(bee.params, {
      duration: duration * 0.2,
      value: PI_2 * sign,
      ease: 'none',
      repeat: -1,
    });

    gsap.to(bee.params, {
      duration,
      angle: PI_2 * sign,
      ease: 'none',
      repeat: -1,
      onUpdate: () => {
        const angle = bee.params.angle + angleOffset;
        const value = bee.params.value + ratioOffset;
        const ratio = Math.sin(value);

        const shiftedValue = value + Math.PI * (reverse ? 0.3 : 0.15);
        const cappedValue = ((shiftedValue % PI_2) + PI_2) % PI_2;
        const turnValue = Math.pow((cappedValue % Math.PI) / Math.PI, 3);
        const turnMultiplier = Math.floor(cappedValue / Math.PI);
        const turnAngle = (turnValue + turnMultiplier) * Math.PI;

        bee.sprite.x = Math.cos(angle) * this._radius * ratio;
        bee.sprite.y = Math.sin(angle) * this._radius * ratio;
        bee.sprite.scaleX = bee.sprite.scaleY = 1 - ratio * 0.1;
        bee.sprite.scaleY = -sign;
        bee.sprite.rotation = Math.PI * 0.5 - angle - turnAngle;
        bee.sprite.zIndex = Math.sin(value + Math.PI * 0.5) > 0 ? 0 : -1;
      },
    });
  }

  public removeBees() {
    this._bees.forEach((bee) => {
      gsap.killTweensOf(bee.params);
      this._view.removeChild(bee.sprite);
    });
    this._bees.length = 0;
  }
}
